import React from 'react';

import SwitchSelector from 'react-switch-selector';

// eslint-disable-next-line import/extensions, import/no-unresolved
import { OptionType } from 'react-switch-selector/dist/SwitchSelector.props';

import FormInvalid from './FormInvalid';

type Props = {
    field: string;
    currentValue: string | number | boolean;
    label: string | JSX.Element;
    options: OptionType<unknown>[];
    error: string;
    handleChange: (value: string | number) => void;
    required?: boolean;
};


function FormSwitchSelector({ field, currentValue, label, options, error, handleChange, required = false }: Props) {
    const hasError = (error ?? false) !== false;

    let currentValueString: string | number | undefined;
    if (typeof currentValue === 'boolean') {
        currentValueString = currentValue ? '1' : '0';
    } else {
        currentValueString = currentValue?.toString();
    }

    const selectedIndex = options.findIndex(({ value }) => value.toString() === currentValueString);

    const onChange = (value: string | number) => {
        handleChange(value);
    };
    return (
        <div className="form-group">
            <label htmlFor={field}>
                {label} {required && <span className="text-danger text-sm">*</span>}
            </label>
            <SwitchSelector
                name={field}
                onChange={onChange}
                options={options}
                forcedSelectedIndex={selectedIndex}
                backgroundColor="#353b48"
                fontColor="#fff"
            />
            {hasError && <FormInvalid message={error} />}
        </div>
    );
}

export default FormSwitchSelector;
